
import { defineComponent } from "vue";
import Button from "./Base.vue";

export default defineComponent({
  components: {
    Button,
  },
  props: {
    outlined: { type: Boolean, default: true },
    text: { type: String, default: "" },
    width: { type: String, default: "167px" },
    height: { type: String, default: "56px" },
    disabled: { type: Boolean, default: false },
  },
});
